import { CurrencyCode } from "../../graphql/generated/generated-types";
import { CustomCurrency } from "./custom-currencies";


export function replaceISKtoKr(formattedValue: string) {
    return formattedValue.replace(CurrencyCode.ISK, CustomCurrency[CurrencyCode.ISK]);
  }